const routes = [
    {
        path: 'processos',
        name: 'Consultas_Processos',
        component: () => import('./listagem/Listagem.vue'),
        meta: {
            keepAlive: true,
            rules: ['CONSULTAS-00'],
        },
    },
    {
        path: 'processos/:id',
        name: 'Consultas_Processos_Detalhar',
        component: () => import('./Detalhar.vue'),
        meta: {
            rules: ['CONSULTAS-01'],
        },
    },
];

export default routes;
